import { render, staticRenderFns } from "./AllScheme.vue?vue&type=template&id=d8d4bd5c&scoped=true&"
import script from "./AllScheme.vue?vue&type=script&lang=js&"
export * from "./AllScheme.vue?vue&type=script&lang=js&"
import style0 from "./AllScheme.vue?vue&type=style&index=0&id=d8d4bd5c&prod&lang=scss&scoped=true&"
import style1 from "./AllScheme.vue?vue&type=style&index=1&id=d8d4bd5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d4bd5c",
  null
  
)

export default component.exports